import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
// import registerServiceWorker from './registerServiceWorker';
import axios from "axios";
import { dialogService } from "react-api-dialog";
import { LoginWithAnalytics, RegisterWithAnalytics } from "./auth";
import LanguageDetector from "./i18n/language-detector";

axios.interceptors.request.use(
  (config) => {
    const timeStamp = `${new Date().getTime()}${Math.floor(Math.random() * 1000)}`;
    const language = LanguageDetector.detect();
    // version: "2.5" for force update
    config.params = { ...config.params, version: "2.5", requestSource: 1657, __t: timeStamp, language: language };
    return config;
  },
  (error) => {
    //
  }
);
// tslint:disable-next-line:no-string-literal
//@ts-ignore
window["login"] = async () => {
  const response = await dialogService.showComponent(LoginWithAnalytics, {
    path: "/login",
    hash: "auth",
    animation: "slide-down",
    showCloseButton: true,
    style: { bottom: 0, right: 0 },
  });
  if (response.cancelled) return false;
  return true;
};
// tslint:disable-next-line:no-string-literal
//@ts-ignore
window["register"] = async () => {
  const response = await dialogService.showComponent(RegisterWithAnalytics, {
    path: "/login",
    hash: "auth",
    animation: "slide-down",
    showCloseButton: true,
    style: { bottom: 0, right: 0 },
  });
  if (response.cancelled) return false;
  return true;
};

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
// registerServiceWorker();
